<div class="logo">
  <a href="https://www.creative-tim.com" class="simple-text">
    کاوشگر کریپتو
    <!-- <div class="logo-img">
            <img src="/assets/img/favicon.ico"/>
        </div>
       -->
  </a>
</div>
<div class="sidebar-wrapper">
  <div *ngIf="isMobileMenu()">
    <form class="navbar-form">
      <span class="bmd-form-group">
        <div class="input-group no-border">
          <input
            type="text"
            value=""
            class="form-control"
            placeholder="Search..."
          />
          <button
            mat-raised-button
            type="submit"
            class="btn btn-white btn-round btn-just-icon"
          >
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </span>
    </form>
  </div>
  <ul class="nav">
    <li
      routerLinkActive="active"
      *ngFor="let menuItem of menuItems"
      class="{{ menuItem.class }} nav-item"
    >
      <ng-container *ngIf="!menuItem.children">
        <a
          class="nav-link"
          target="_blank"
          href="{{ menuItem.path }}"
          *ngIf="menuItem.externalLink"
        >
          <i class="material-icons">{{ menuItem.icon }}</i>
          <p>{{ menuItem.title }}</p>
        </a>

        <a
          class="nav-link"
          *ngIf="!menuItem.externalLink"
          [routerLink]="[menuItem.path]"
        >
          <i class="material-icons">{{ menuItem.icon }}</i>
          <p>{{ menuItem.title }}</p>
        </a>
      </ng-container>

      <ng-container *ngIf="menuItem.children">
        <a class="nav-link" (click)="menuItem.expanded = !menuItem.expanded" style="cursor: pointer">
          <i class="material-icons">{{ menuItem.icon }}</i>
          <p>{{ menuItem.title }} <span class="caret-icon" [class.rotated]="menuItem.expanded">◂</span></p>
        </a>
        <ul class="nav submenu" *ngIf="menuItem.expanded">
          <li *ngFor="let child of menuItem.children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
            <a class="nav-link submenu-link" [routerLink]="[child.path]">
              <i class="material-icons">{{ child.icon }}</i>
              <p>{{ child.title }}</p>
            </a>
          </li>
        </ul>
      </ng-container>
    </li>
  </ul>
</div>
<div class="version-wrap">
  <span>
    Backend Version : <strong>{{ appVersion }}</strong>
  </span>
</div>
